// src/components/ImageZoomModal.tsx
import { useEffect } from "react";

interface ImageZoomModalProps {
  src: string;
  onClose: () => void;
}

export default function ImageZoomModal({ src, onClose }: ImageZoomModalProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleEsc);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 bg-black/85 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}>
      <img
        src={src}
        alt="Full"
        className="max-h-[90vh] max-w-[95vw] object-contain rounded-2xl shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
